import React from 'react';
import { Button } from 'reactstrap';

export const SuccessState = ({ onBackToSelection, onDone }) => (
    <div>
        <div className="alert alert-success" role="alert">
            <strong>✓ Request submitted successfully!</strong>
            <br />
            A CHE administrator will review your request.
        </div>
        <p>Would you like to submit another request?</p>
        <div className="d-flex justify-content-between mt-4">
            <Button color="secondary" outline onClick={onBackToSelection}>
                ← Back to action selection
            </Button>
            <Button color="primary" onClick={onDone}>
                Done — Close Modal
            </Button>
        </div>
    </div>
);
